<template>
<div class="chapter">
<div class="inner_page">
<h2 id="charts">Charts and Figures</h2>
<div class="image"><img alt="6603_DOTS.jpg" src="Images/6603_DOTS.jpg"/></div>
<p class="firstcenter"><span href="#/Text/chap2#figure-1" title="Link target outside of Sample">Conversion: <em class="i">A Spiritual Process</em> <em class="i">(chap. 2)</em></span></p>
<p class="firstcenter"><span href="#/Text/chap3#chart-1" title="Link target outside of Sample">Some Contrasts in the Gospel Content <em class="i">(chap. 3)</em></span></p>
<p class="firstcenter"><span href="#/Text/chap4#figure-2" title="Link target outside of Sample">Contrasting Views of God <em class="i">(chap. 4)</em></span></p>
<p class="firstcenter"><span href="#/Text/chap4#chsv" title="Link target outside of Sample">Come Home: <em class="i">Simplified Version</em> (for sharing) <em class="i">(chap. 4)</em></span></p>
<p class="firstcenter"><span href="#/Text/chap5#figure-3" title="Link target outside of Sample">God’s Method of Salvation <em class="i">(chap. 5)</em></span></p>
<p class="firstcenter"><span href="#/Text/chap10#figure-4" title="Link target outside of Sample">Three Ways to Converse About Christ <em class="i">(chap. 10)</em></span></p>
<p class="firstcenter"><span href="#/Text/chap10#chart-2" title="Link target outside of Sample">Turning Conversations to Christ <em class="i">(chap. 10)</em></span></p>
<p class="firstcenter"><span href="#/Text/chap10#figure-5" title="Link target outside of Sample">Conversational Evangelism <em class="i">(chap. 10)</em></span></p>
<p class="firstcenter"><span href="#/Text/chap10#chart-3" title="Link target outside of Sample">The Goal in Witnessing Affects the Methods <em class="i">(chap. 10)</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chartsandfigures.vue?67eb3ba9